import React from 'react';
import ReactDOM from 'react-dom';

import Widget from './widget';

ReactDOM.render(
  <React.StrictMode>
    <Widget />
  </React.StrictMode>,
  document.getElementById('hilbi-widget'),
);
